var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"150px"}},[_c('b-form-timepicker',{key:_vm.initValue,attrs:{"disabled":_vm.isDisabled,"placeholder":_vm.placeholder},on:{"hidden":_vm.selectTime},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }